export default __webpack_public_path__ + "static/media/banner-tablet-bg-blue2-template.1078e40b.svg";